import React from 'react';
import { Column, Text } from '@ydistri/ds';
import { Empty } from 'antd';
import { styled } from 'styled-components';
import AsoScopes from '../AsoScopes';
import AsoGlobalLayers from '../AsoLayers/AsoGlobalLayers';
import AsoStoreTiers from '../AsoStoreTiers';
import AsoSettings from '../AsoSettings';
import AsoComputation from '../AsoComputation';
import { useStableParams } from '../../../routes/useStableParams';
import AsoRequest from '../AsoRequest/AsoRequest';
import AsoScenario from '../AsoScenario/AsoScenario';
import AsoScenarioStatusOverlay from '../../../components/global/ContentOverlay/AsoScenarioStatusOverlay';

const AsoContent: React.FC = () => {
  const { asoRequestId, asoScenarioId } = useStableParams();

  const ready = asoRequestId && asoScenarioId;

  if (!ready) {
    return (
      <Centered>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={false} />
        <Text style={{ opacity: 0.8, textAlign: 'center' }}>
          Please select an ASO request and scenario from the dropdowns to continue.
        </Text>
        <Column $gap="1rem" $alignItems="flex-start">
          <AsoRequest />
          <AsoScenario />
        </Column>
      </Centered>
    );
  }

  return (
    <ContentArea>
      <Column>
        <AsoScopes />
        <AsoGlobalLayers />
        <AsoStoreTiers />
        <AsoSettings />
        <AsoComputation />
      </Column>
      <AsoScenarioStatusOverlay />
    </ContentArea>
  );
};

export default AsoContent;

const Centered = styled(Column)`
  min-height: 50vh;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;

const ContentArea = styled.div`
  position: relative;
`;
